import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Stack, Typography } from "@mui/material";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    joinParts,
} from "components/detail";

export const ImageShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const record = data?.data;

    // 카테고리별 S3 경로 세그먼트
    const categoryP = record?.category === "CENTER" ? "centers" :
                    record?.category === "USER" ? "users" :
                    record?.category === "CHILD" ? "childs" :
                    record?.category === "BOARD" ? "boards" :
                    record?.category === "POST" ? "posts" :
                    record?.category === "PRESENTATION" ? "presentations" :
                    "images";

    // 확장자 소문자 변환
    const extensionL = record?.extension ? record.extension.toLowerCase() : "";

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    이미지 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    이미지를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem
                            label="파일 이름"
                            value={
                                record?.name != null
                                    ? `${record.name}.${record.extension}`
                                    : undefined
                            }
                        />
                        <FieldItem label="위치" value={record?.prefix} />
                        <FieldItem
                            label="연관 Entity"
                            value={joinParts([record?.category, record?.targetId], "-")}
                        />
                        <FieldItem label="생성일" value={record?.createdDate} />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="미리보기">
                    <img
                        src={record?.prefix + categoryP + "/" + record?.targetId + "/" + record?.name + "." + extensionL}
                        width={500}
                        alt="image"
                    />
                </DetailSection>
            </Stack>
        </Show>
    );
};
